import * as React from 'react';
import Svg, {
  SvgProps, G, Rect, Path,
  Defs, ClipPath,
} from 'react-native-svg';

const AvatarIcon = (props: SvgProps) => (
  <Svg
    width={32}
    height={33}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Rect width={32} height={32} y={0.5} fill="#E6EEF7" rx={16} />
      <Path
        fill="#548FC8"
        d="M26 34.5v-7.077a4.885 4.885 0 0 0-1.465-3.481A5.04 5.04 0 0 0 21 22.5H11a5.04 5.04 0 0 0-3.536 1.442A4.885 4.885 0 0 0 6 27.423V34.5M16 20.5a5.333 5.333 0 1 0 0-10.667A5.333 5.333 0 0 0 16 20.5Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={32} height={32} y={0.5} fill="#fff" rx={16} />
      </ClipPath>
    </Defs>
  </Svg>
);

export default AvatarIcon;
